import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Temporary placeholder data - you will replace the images with actual client work
const projects = [
  { id: 1, title: 'Downtown Plaza Neon', category: 'Illuminated', img: 'https://via.placeholder.com/600x400/0B198F/00C6FF?text=Neon+Sign' },
  { id: 2, title: 'Corporate Park Entrance', category: 'Monument', img: 'https://via.placeholder.com/600x600/050B40/ffffff?text=Monument+Sign' },
  { id: 3, title: 'Local Cafe Windows', category: 'Window Graphics', img: 'https://via.placeholder.com/600x400/00C6FF/0B198F?text=Window+Decals' },
  { id: 4, title: 'Tech Startup Lobby', category: 'Illuminated', img: 'https://via.placeholder.com/600x800/0B198F/ffffff?text=Lobby+Sign' },
  { id: 5, title: 'Boutique Awning', category: 'Awnings', img: 'https://via.placeholder.com/600x400/F8FAFC/0B198F?text=Custom+Awning' },
  { id: 6, title: 'Suburban Community Sign', category: 'Monument', img: 'https://via.placeholder.com/600x600/050B40/00C6FF?text=Stone+Monument' },
];

const categories = ['All', 'Illuminated', 'Monument', 'Window Graphics', 'Awnings'];

const PortfolioPage = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="pt-32 pb-24 min-h-screen bg-brand-light">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* Page Header */}
        <div className="text-center mb-16">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-heading font-bold text-brand-dark mb-4"
          >
            Our <span className="text-brand-blue">Work</span>
          </motion.h1>
          <div className="w-24 h-1 bg-brand-cyan mx-auto rounded-full mb-8"></div>
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveFilter(category)}
                className={`px-6 py-2 rounded-full font-medium text-sm transition-all duration-300 ${
                  activeFilter === category 
                    ? 'bg-brand-blue text-white shadow-md' 
                    : 'bg-white text-gray-600 hover:bg-brand-cyan/10 hover:text-brand-blue'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Masonry-style Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence>
            {filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4 }}
                className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer bg-white"
              >
                <img 
                  src={project.img} 
                  alt={project.title} 
                  className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <span className="text-brand-cyan font-bold text-sm tracking-wider uppercase mb-1">{project.category}</span>
                  <h3 className="text-white font-heading font-bold text-xl">{project.title}</h3>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

      </div>
    </div>
  );
};

export default PortfolioPage;